export const NONE = 'NONE';
export const SYNCED = 'SYNCED';
export const WAITING = 'WAITING';
export const DISCONNECTED = 'DISCONNECTED';
